import { getProviderById } from '@/constants/providers'
import { Game, IProviderGamesResponse, ProviderGamesBody } from '@/types'
import { getThumbnailUrl } from '@/utils/game'
import { api } from '../..'

export const getProviderGamesFn = async (body: ProviderGamesBody) => {
  const { data } = await api.post<IProviderGamesResponse>(
    '/game/getProviderGames',
    body
  )

  return {
    ...data,
    games: data.games.map<Game>((game) => {
      return {
        id: game.identifier,
        name: game.title,
        thumbnail: {
          url: getThumbnailUrl(game.identifier),
        },
        provider: getProviderById(game.provider),
        path: `/games/${game.identifier}`,
        rtp: game.payout,
        isLive: game.hasLive,
      }
    }),
  }
}

type GetRecentlyPlayedResponse = {
  myRecentlyPlayed: {
    _id: string
    count: number
  }[]
}

export const getFavouriteGamesFn = async () => {
  const { data } = await api.get<GetRecentlyPlayedResponse>(
    '/game/getRecentlyPlayed'
  )

  return data.myRecentlyPlayed.map((item) => {
    const { _id } = item

    return {
      id: _id,
      name: _id,
      path: `/games/${_id}`,
      thumbnail: {
        url: getThumbnailUrl(_id),
      },
    }
  })
}
